<template>
  <div>
    <!--资讯详情-->
    <!--面包屑-->
    <section class="crumbs-wrap">
      <article class="crumbs">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'Home' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'exhibition' }">企业展示</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'list' }">资讯列表</el-breadcrumb-item>
          <el-breadcrumb-item>资讯详情</el-breadcrumb-item>
        </el-breadcrumb>
      </article>
    </section>
    <section class="main-wrap">
      <div class="main">
        <div class="header">
          <p class="header-title">{{ detailsData.title }}</p>
          <p class="header-con">
            <span class="header-con-sj">{{ detailsData.releaseTime }}</span>
            <span class="header-con-txt">来源:{{ detailsData.sourceLebal }}
             <!-- <span>来源：</span>
              <span v-if="detailsData.source === '0'">内部</span>
              <span v-else-if="detailsData.source === '1'">外部</span>-->
            </span>
          </p>
        </div>
        <div class="text ql-container ql-snow  ql-editor" v-html="detailsData.content">
          <!--<p class="text-p">-->
          <!--{{ detailsData.content }}-->
          <!--</p>-->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { detailsSee } from '@/api/enterprise/detailsSee' // 请求接口

export default {
  name: 'DetailsSee',
  data() {
    return {
      seeID: '',
      detailsData: ''
    }
  },
  watch: {
    // 监听路由变化
    $route(to, from) {
      this.seeID = this.$route.query.seeID
      detailsSee({}, this.seeID)
        .then(res => {
          this.detailsData = res.result[0]
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  created() {
    this.seeID = this.$route.query.seeID
    detailsSee({}, this.seeID)
      .then(res => {
        this.detailsData = res.result[0]
      })
      .catch(error => {
        console.log(error)
      })
  },
  mounted() {}
}
</script>
<style scoped lang='scss'>
.crumbs-wrap {
  width: 100%;
  .crumbs {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;
  }
}
.main-wrap {
  width: 100%;
  .main {
    width: 1200px;
    min-height: 400px;
    margin: 0 auto;
    border: 1px solid #e9e9e9;
    padding: 40px 50px 50px 50px;
    margin-bottom: 20px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    .header {
      text-align: center;
      height: 80px;
      border-bottom: 1px solid #dadada;
      .header-title {
        font-size: 22px;
        padding-bottom: 20px;
      }
      .header-con {
        font-size: 14px;
        .header-con-sj {
          color: #a3a3a3;
          padding-right: 15px;
        }
        .header-con-txt {
          color: #a3a3a3;
        }
      }
    }
    .text {
      width: 100%;
      padding-top: 40px;
      .text-p {
        color: #555555;
        font-size: 14px;
        line-height: 28px;
        text-indent: 2rem;
      }
    }
  }
}
</style>
